module.exports = __webpack_public_path__ + "img/13d.8856ebca.png";